import { NgModule } from '@angular/core';

import { MasterEdit5Actions } from './master-edit-5.actions';

@NgModule({
  providers: [
    MasterEdit5Actions
  ]
})
export class MasterEdit5ActionsModule {}
